export const paintings = [
  {
    id: 1,
    url: "/pics/19.jpeg",
    title: "Закатное озеро",
    titleEn: "Sunset Lake",
    category: "landscape",
    year: "2022",
    size: "70x90 см",
    technique: "Масло, холст",
    status: "available",
    price: "45 000",
    description: "Умиротворяющий пейзаж с озером, отражающим нежные краски заката. Тёплые оттенки золота и розового создают атмосферу покоя и гармонии."
  },
  {
    id: 2,
    url: "/pics/18.jpeg",
    title: "Уютный полдень",
    titleEn: "Cozy Afternoon",
    category: "portrait",
    year: "2023",
    size: "70x90 см",
    technique: "Масло, холст",
    status: "sold",
    description: "Интимный портрет в интерьере с букетом пионов и раскрытой книгой. Тёплый свет наполняет пространство ощущением домашнего уюта."
  },
  {
    id: 3,
    url: "/pics/17.jpeg",
    title: "Труд на земле",
    titleEn: "Working the Land",
    category: "landscape",
    year: "2021",
    size: "80x60 см",
    technique: "Масло, холст",
    status: "available",
    price: "55 000",
    description: "Динамичная сельская сцена, запечатлевшая момент работы в поле. Энергия труда и красота летнего дня сливаются в единое целое."
  },
  {
    id: 4,
    url: "/pics/16.jpeg",
    title: "Охотники на привале",
    titleEn: "Hunters at Rest",
    category: "portrait",
    year: "2020",
    size: "90x70 см",
    technique: "Масло, холст",
    status: "available",
    price: "75 000",
    description: "Вариация на тему знаменитой картины Перова. Три охотника делятся историями в поле, окружённые снаряжением и добычей."
  },
  {
    id: 5,
    url: "/pics/15.jpeg",
    title: "Деревенский дом у воды",
    titleEn: "Rural Homestead",
    category: "landscape",
    year: "2022",
    size: "60x80 см",
    technique: "Масло, холст",
    status: "available",
    price: "48 000",
    description: "Идиллический пейзаж с деревянным домом у тихого пруда. Летняя зелень и отражения в воде создают ощущение безмятежности."
  },
  {
    id: 6,
    url: "/pics/14.jpeg",
    title: "Тропинка в саду",
    titleEn: "Garden Path in Bloom",
    category: "garden",
    year: "2021",
    size: "40x50 см",
    technique: "Акварель, бумага",
    status: "available",
    price: "28 000",
    description: "Залитая солнцем садовая дорожка среди цветущих лилий и флоксов. Лёгкость акварели передаёт трепет летнего дня."
  },
  {
    id: 7,
    url: "/pics/13.jpeg",
    title: "Храм на холме",
    titleEn: "Church on the Hill",
    category: "landscape",
    year: "2020",
    size: "50x60 см",
    technique: "Акварель, бумага",
    status: "sold",
    description: "Белая церковь с луковичным куполом на зелёном холме под сенью старой берёзы. Образ русской духовности и природы."
  },
  {
    id: 8,
    url: "/pics/12.jpeg",
    title: "Весенние берёзы",
    titleEn: "Birch Reflections in Spring",
    category: "landscape",
    year: "2022",
    size: "70x90 см",
    technique: "Масло, холст",
    status: "available",
    price: "52 000",
    description: "Стройные берёзы у кромки воды, их силуэты отражаются в зеркальной глади. Первая листва говорит о пробуждении природы."
  },
  {
    id: 9,
    url: "/pics/11.jpeg",
    title: "Подсолнухи и небо",
    titleEn: "Sunflowers Against the Sky",
    category: "stilllife",
    year: "2023",
    size: "80x60 см",
    technique: "Масло, холст",
    status: "available",
    price: "42 000",
    featured: true,
    description: "Яркий натюрморт с тяжёлыми головками подсолнухов на фоне драматичного неба. Сила и красота природы в каждом мазке."
  },
  {
    id: 10,
    url: "/pics/10.jpeg",
    title: "Плакучие берёзы",
    titleEn: "Birches by the Calm Water",
    category: "landscape",
    year: "2021",
    size: "60x80 см",
    technique: "Масло, холст",
    status: "sold",
    description: "Изящные берёзы склоняются над тихой водой, их нежная листва ловит солнечный свет. Поэзия русского пейзажа."
  },
  {
    id: 11,
    url: "/pics/9.jpeg",
    title: "Пруд с кувшинками",
    titleEn: "Summer Pond with Water Lilies",
    category: "landscape",
    year: "2022",
    size: "50x70 см",
    technique: "Масло, холст",
    status: "available",
    price: "46 000",
    featured: true,
    description: "Живописный пруд с белыми кувшинками, камышами и утками под сенью ив. Полнота летнего дня."
  },
  {
    id: 12,
    url: "/pics/8.jpeg",
    title: "Монмартр",
    titleEn: "Montmartre View",
    category: "urban",
    year: "2019",
    size: "70x50 см",
    technique: "Масло, холст",
    status: "private",
    featured: true,
    description: "Живая парижская улица с видом на базилику Сакре-Кёр. Атмосфера богемного Монмартра и очарование Парижа."
  },
  {
    id: 13,
    url: "/pics/7.jpeg",
    title: "Сестры",
    titleEn: "Siblings and Bear",
    category: "portrait",
    year: "2020",
    size: "50x60 см",
    technique: "Масло, холст",
    status: "private",
    description: "Нежная сцена: старшая сестра с младенцем на руках и плюшевый мишка. Теплота семейных уз."
  },
  {
    id: 14,
    url: "/pics/6.jpeg",
    title: "Река и небо",
    titleEn: "River Reflections",
    category: "landscape",
    year: "2022",
    size: "60x90 см",
    technique: "Масло, холст",
    status: "available",
    price: "58 000",
    featured: true,
    description: "Широкая река отражает драматичное небо с облаками. Зелёные берега и глубина пространства создают ощущение свободы."
  },
  {
    id: 15,
    url: "/pics/5.jpeg",
    title: "Скамейка в саду",
    titleEn: "Garden Bench Respite",
    category: "garden",
    year: "2021",
    size: "70x50 см",
    technique: "Масло, холст",
    status: "sold",
    description: "Старая деревянная скамейка в тенистом уголке сада среди жёлтых и розовых цветов. Приглашение к отдыху и созерцанию."
  },
  {
    id: 16,
    url: "/pics/4.jpeg",
    title: "Сумерки над водой",
    titleEn: "Twilight Waters",
    category: "landscape",
    year: "2023",
    size: "50x70 см",
    technique: "Масло, холст",
    status: "available",
    price: "44 000",
    description: "Атмосферный пейзаж с переливами сумеречного неба в спокойной воде. Медитативное настроение и тонкая игра света."
  },
  {
    id: 17,
    url: "/pics/3.jpeg",
    title: "Ромашки в стакане",
    titleEn: "Daisies in a Glass Vase",
    category: "stilllife",
    year: "2020",
    size: "40x30 см",
    technique: "Масло, холст",
    status: "available",
    price: "25 000",
    description: "Солнечный букет ромашек в простом стеклянном сосуде на фоне дерева. Радость простых вещей."
  },
  {
    id: 18,
    url: "/pics/2.jpeg",
    title: "Розовая роза",
    titleEn: "Pink Rose Study",
    category: "stilllife",
    year: "2021",
    size: "30x40 см",
    technique: "Акварель, бумага",
    status: "private",
    description: "Детальное изображение раскрывшейся розы. Нежность лепестков и тонкие переходы цвета."
  },
  {
    id: 19,
    url: "/pics/1.jpeg",
    title: "Подводный сад",
    titleEn: "Underwater Garden",
    category: "underwater",
    year: "2022",
    size: "80x60 см",
    technique: "Масло, холст",
    status: "sold",
    featured: true,
    description: "Импрессионистическая подводная сцена с яркими рыбками среди кораллов. Танец цвета и движения."
  }
];

export const categories = [
  { id: 'all', name: 'Все работы', icon: 'grid' },
  { id: 'landscape', name: 'Пейзажи', icon: 'mountain' },
  { id: 'portrait', name: 'Портреты', icon: 'user' },
  { id: 'stilllife', name: 'Натюрморты', icon: 'flower' },
  { id: 'urban', name: 'Городские сцены', icon: 'building' },
  { id: 'garden', name: 'Сады и цветы', icon: 'leaf' },
  { id: 'underwater', name: 'Подводный мир', icon: 'waves' },
];

export const exhibitions = [
  {
    id: 1,
    title: "Русский пейзаж",
    date: "15.03.2023 - 30.04.2023",
    location: "Городская художественная галерея, Москва",
    description: "Персональная выставка пейзажей русской природы.",
    status: "upcoming"
  },
  {
    id: 2,
    title: "Цветы и натюрморты",
    date: "10.06.2022 - 25.07.2022",
    location: "Культурный центр «Палитра», Санкт-Петербург",
    description: "Тематическая экспозиция натюрмортов с цветочными композициями.",
    status: "upcoming"
  },
  {
    id: 3,
    title: "Портрет современника",
    date: "05.09.2021 - 15.10.2021",
    location: "Выставочный зал «Арт-город», Казань",
    description: "Коллективная выставка портретной живописи.",
    status: "past"
  },
  {
    id: 4,
    title: "Времена года",
    date: "12.12.2020 - 31.01.2021",
    location: "Галерея современного искусства, Нижний Новгород",
    description: "Сезонные пейзажи и природные мотивы в работах художников.",
    status: "past"
  },
];

export const getFeaturedPaintings = () => paintings.filter(p => p.featured);
export const getAvailablePaintings = () => paintings.filter(p => p.status === 'available');
export const getPaintingsByCategory = (category) =>
  category === 'all' ? paintings : paintings.filter(p => p.category === category);
